class MegaMenuPanel extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick.bind(this));
  }

  #onClick(event) {
    const trigger = event.target.closest('[data-tab-trigger]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('data-tab-trigger');

    this.querySelectorAll('[data-tab-trigger]').forEach((el) => {
      const isActive = el.getAttribute('data-tab-trigger') === targetId;
      el.classList.toggle('is-active', isActive);
      el.setAttribute('aria-expanded', isActive);
    });

    this.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      const isActive = panel.getAttribute('data-tab-panel') === targetId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  open() {
    this.classList.add('is-visible');
    this.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.classList.remove('is-visible');
    this.setAttribute('aria-hidden', 'true');
  }
}

if (!customElements.get('mega-menu-panel')) {
  customElements.define('mega-menu-panel', MegaMenuPanel);
}

const MEGA_MENU_CLOSE_DELAY = 200;

class HeaderMegaMenu extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('.header__menu-item');
    this.pairs = [];
    this.closeTimer = null;

    this.items.forEach((item) => {
      const key = item.getAttribute('data-menu-item');
      const panel = key ? this.querySelector(`mega-menu-panel[data-menu-item="${key}"]`) : null;
      if (!panel) return;

      this.pairs.push({ item, panel });

      // Listen on both the trigger and the panel itself, so moving the
      // mouse from one to the other (even through the gap between them)
      // never registers as "left" — only leaving both closes it.
      [item, panel].forEach((el) => {
        el.addEventListener('mouseenter', () => this.#requestOpen(item, panel));
        el.addEventListener('mouseleave', () => this.#requestClose(item, panel));
      });

      item.addEventListener('focusin', () => this.#requestOpen(item, panel));
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget) && !panel.contains(event.relatedTarget)) {
          this.#requestClose(item, panel);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.#closeAll();
    });
  }

  #requestOpen(item, panel) {
    clearTimeout(this.closeTimer);
    this.#closeAllExcept(panel);
    item.classList.add('is-open');
    panel.open();
  }

  #requestClose(item, panel) {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      item.classList.remove('is-open');
      panel.close();
    }, MEGA_MENU_CLOSE_DELAY);
  }

  #closeAllExcept(exceptPanel) {
    this.pairs.forEach(({ item, panel }) => {
      if (panel === exceptPanel) return;
      item.classList.remove('is-open');
      panel.close();
    });
  }

  #closeAll() {
    clearTimeout(this.closeTimer);
    this.pairs.forEach(({ item, panel }) => {
      item.classList.remove('is-open');
      panel.close();
    });
  }
}

if (!customElements.get('header-mega-menu')) {
  customElements.define('header-mega-menu', HeaderMegaMenu);
}
